export default function BreadB() {
  return (
    <div>
      <div className="container">
        <div className="row center">
          <h2 className="header col s12 light">B vada</h2>
          <p className="headline light">Vienas patinėlis.</p>
        </div>
        <div className="row center">
          <img src="photos/breed-b/pedigree.png" title="B Breed" alt="breed-b" width="100%" />
          <p>Deja šuniukas neišgyveno</p>
          <img src="photos/breed-b/1.jpg" title="B Breed Puppy 1" alt="breed-b-puppy-1" width="100%" />
        </div>
      </div>
    </div>
  );
}
